import React from 'react';
import { useTranslation } from 'react-i18next';
import { BreadcrumbStyled } from './Project.styled';

const ProjectBreadCrumb = () => {
    const { t } = useTranslation();

    const links = [
        {
            url: '/projects',
            label: t('sidebar.allProjects'),
        },
        {
            url: '#',
            label: t('contributions.globalView.projectInfo'),
        },
    ];

    return <BreadcrumbStyled colorTheme="primary" elements={links} />;
};

export default ProjectBreadCrumb;
